import { AccordionItem, Text, List } from 'braid-design-system';
export const RightsReservedByUs = () => (
  <AccordionItem id="rights-reserved" label="Rights reserved by us">
    <List type="number" start={39}>
      <Text>
        If you breach these Terms and fail to remedy such breach within 14 days
        of us notifying you in writing, we may restrict or terminate your access
        to the SEEK API.
      </Text>
      <Text>We may control the use of the SEEK API by you at any time.</Text>
      <Text>
        We may provide you with support or modifications for the SEEK API, at
        our sole discretion.
      </Text>
      <Text>
        We may stop providing support or modifications to you at any time
        without notice or liability to you if we reasonably consider that doing
        so is unlikely to be detrimental to you. If withdrawing support or the
        provision of modifications to you is reasonably likely to be detrimental
        to you, we will notify you at least 30 days prior to ceasing providing
        such support or modifications. If you do not agree to the withdrawal of
        this support or modifications, you may terminate these Terms by
        discontinuing your use of the SEEK API with 5 days&apos; written notice
        to us.
      </Text>
      <Text>
        We may release subsequent versions or new features of the SEEK API and
        require that you use those subsequent versions or new features. Your
        continued use of the SEEK API following a subsequent release of versions
        or features will be deemed your acceptance of modifications.
      </Text>
      <Text>
        For each functionality listed in Sections A to I below, we may release
        subsequent versions of each functionality. Where reasonably possible, we
        will announce version changes at least 30 days in advance of its release
        to allow you to prepare for any impact. You are required to move to a
        supported version before the current version reaches end of support date
        for the integration to remain function. Your continued use of each
        functionality following a subsequent release, will be deemed your
        acceptance of the modifications.
      </Text>
    </List>
  </AccordionItem>
);
